import React, { useState, useRef } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_OWNER_PASSWORD } from "../../actions/mutations";
import { Link } from "react-router-dom";
import NavbarAccount from "../Layout/Navbar_account";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import editElem from "../../utils/editElem";

let emoji = Math.random() < 0.5 ? "😜" : "🤭";

const ResetPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [updateOwnerPassword] = useMutation(UPDATE_OWNER_PASSWORD);
  const form = useRef();

  document.title = "Carte Verte : Réinitialisation de mot de passe";

  const submitForm = (event) => {
    event.preventDefault();

    editElem("#login", "disabled", true);
    editElem(".smallLoader2", "display", "block");

    let error = false;
    const formattedEmail = email.trim().toLowerCase();
    if (
      !formattedEmail.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
      )
    ) {
      editElem(".emailError", "display", "block");

      error = true;
    }

    if (error) {
      editElem("#login", "disabled", false);
      editElem(".smallLoader2", "display", "none");
    } else {
      updateOwnerPassword({
        variables: {
          data: {
            email: formattedEmail,
          },
        },
      })
        .then((response) => {
          editElem(".success", "display", "block");
          editElem("#login", "disabled", false);
          editElem(".smallLoader2", "display", "none");
        })
        .catch((e) => {
          console.log(e.toString());
          if (e.toString().includes("Email incorrect")) {
            editElem(".loginError", "display", "block");
            console.warn(e.toString());
          } else if (
            e.toString().includes("Looks like an internal server error") ||
            e.toString().includes("Failed to fetch") 

          ) {
            editElem(".networkError", "display", "block");
            console.warn("Vérifer votre connexion internet");
          } else {
            // includes Nodemailer error
            editElem(".serverNetworkError", "display", "block");
            console.warn(
              " Notre serveur est déconnecté. Veuillez réessayer plus tard et nous contacter si cela persiste! contact@carteverte.co"
            );
          }
          editElem("#login", "disabled", false);
          editElem(".smallLoader2", "display", "none");
        });
    }
  };

  return (
    <div id="loginContainer">
      <NavbarAccount isActive="hidden" cta="no" />
      <div id="imgContainer">
        <Link to="/#">
          <img
            className="logoLoginSignup"
            src="/images/icon-blanche.png"
            alt=""
          />
        </Link>
      </div>
      <Link className="returnLink" to="/login">
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ fontSize: "1.4rem", marginRight: "1rem" }}
        />
        Me connecter
      </Link>
      <div id="formContainer">
        <form ref={form} id="form" onSubmit={submitForm}>
          <div id="formHeader">
            <h1 id="bonjour">Mot de passe oublié ?</h1>
            <h1 id="welcom">Au moins ça arrive à tout le monde</h1>
            <span> {emoji}</span>
          </div>
          <div id="emailContainer">
            <p>Email de votre compte</p>
            <input
              name="user_email"
              placeholder="exemple@commerce.fr"
              type="text"
              onChange={(event) => {
                editElem(".emailError", "display", "none");
                editElem(".loginError", "display", "none");
                setEmail(event.target.value);
              }}
            />
            <p className="error emailError">Email invalide !</p>
          </div>
          <div className="cnx">
            <button
              id="login"
              type="submit"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-around",
                width: "27rem",
              }}
            >
              Réinitialiser mon mot de passe
              <div className="smallLoader2"></div>
            </button>
          </div>
          <p className="success">
            Un nouveau mot passe vient de vous être envoyé par email.
            <br />{" "}
            <span style={{ fontSize: "1rem", color: "var(--color-grey)" }}>
              (Veuillez vérifier dans les spams également).
            </span>
            <br />
            <br /> Utlisez ce mot de passe pour{" "}
            <Link
              style={{
                color: "var(--color-secondary)",
                textDecoration: "underline",
              }}
              to="/login"
            >
              vous connecter
            </Link>
            <br /> et pensez à le changer par la suite.
          </p>
          <p className="error loginError">Email incorrect</p>
          <p className="error networkError">
            Veuillez Vérifier votre connexion internet
          </p>
          <p className="error networkError serverNetworkError">
            Notre serveur est déconnecté. Veuillez réessayer plus tard et nous
            contacter si cela persiste! contact@carteverte.co
          </p>
        </form>
      </div>
    </div>
  );
};

export { ResetPasswordPage as default };
